enum ProfileStatusesEnum {
  BOOKED = 'BOOKED',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  PROCESSING = 'PROCESSING',
}

export default ProfileStatusesEnum;
